<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError == '400') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.incident-code.errors.bad-request' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.incident-code.dialog.create.header' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		@if (httpError == '409') {
			<mat-error>{{ 'mes.incident-code.errors.duplicate' | translate }}</mat-error>
		}

		@if (controls['alias'].invalid && controls['alias'].touched) {
			<mat-error>
				{{ 'mes.incident-code.errors.invalid-characters' | translate }}
			</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">
				{{ 'mes.incident-code.shared.alias' | translate }}
			</mat-label>
			<input maxlength="255" matInput formControlName="alias" />
		</mat-form-field>

		@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>
				{{ 'mes.incident-code.errors.invalid-characters' | translate }}
			</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">
				{{ 'mes.incident-code.shared.name' | translate }}
			</mat-label>
			<input maxlength="255" matInput formControlName="name" />
		</mat-form-field>

		@if (controls['group'].invalid && controls['group'].touched) {
			<mat-error>
				{{ 'mes.incident-code.errors.invalid-characters' | translate }}
			</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">
				{{ 'mes.incident-code.shared.group' | translate }}
			</mat-label>
			<input type="text" maxlength="255" matInput formControlName="group" [matAutocomplete]="autoGroup" />
			<mat-autocomplete #autoGroup="matAutocomplete">
				@for (option of filteredGroups | async; track option) {
					<mat-option [value]="option">{{ option }}</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>

		<mat-label class="mat-body-1">
			{{ 'mes.incident-code.shared.is-active.label' | translate }}
		</mat-label>
		<mat-checkbox formControlName="isActive" />
	</mat-dialog-content>
	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.incident-code.buttons.okbtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.incident-code.buttons.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
